module.exports = __webpack_public_path__ + "assets/badbb25ab09673679b8cb094fb548488.png";